import { toast } from "vue3-toastify";
import Timer from "@/utils/Timer";
import API from "@/utils/API";

class MessageReplie {
  constructor(app) {
    this.app = app;
  }

  init() {
    Timer.addRequest("msg_replie", {
      timer: async () => {
        for (let key in this.app.$root.msg_replie) {
          if (Object.hasOwnProperty.call(this.app.$root.msg_replie, key)) {
            let data = this.app.$root.msg_replie[key];
            this.msg_replie_update(data, key);
            this.app.$root.global.fetch.msg_replie++;
          }
        }
      },
    });
  }

  async msg_replie_update(data, key) {
    let status_msg = {
      sent          : $root.$e("Commande envoyer"),
      in_progress   : $root.$e("En crours"),
      ok            : $root.$e("Validé"),
      paused        : $root.$e("En pause"),
      rejected      : $root.$e("Rejetée"),
      failed        : $root.$e("Erreur"),
      canceled      : $root.$e("Annulé ou arrêté"),
      timeout       : $root.$e("Temps écoulée"),
    };

    if (this.app.$root.msg_replie[data.id]?.fetch) return;
    let msg_replie = this.app.$root.msg_replie[data.id];

    msg_replie.fetch = true;
    let command = await API.get("command", {
      CmdId: data.id,
    });
    msg_replie.fetch = false;

    let duration = Object.hasOwnProperty.call(msg_replie, "duration")
      ? msg_replie.duration.replace("ms", "")
      : 0;

    duration = parseInt(duration);

    if (Object.hasOwnProperty.call(data, "function")) {
      data.function(command);
      return;
    }

    if (msg_replie.loaded == undefined) {
      msg_replie.ToastId = toast.loading(data.name, this.app.$root.toastMsgReplie);

      msg_replie.loaded = true;
      msg_replie.maxTime = Date.now() + parseInt(ENV.KILL_RESPONSE_API);
    }

    if (msg_replie.close == undefined) {
      let update = {
        render:
          data.name +
          (Object.hasOwnProperty.call(msg_replie, "last_status") &&
            status_msg[command.last_status]
            ? " : <strong>" + $root.$e(command.last_status) + "</strong>"
            : ""),
      };

      let end = false;

      if (msg_replie.maxTime <= Date.now()) {
        update.type = toast.TYPE.ERROR;
        end = true;
        data.name += " " + $root.$e("(Temps écoulée)");

        if (Object.hasOwnProperty.call(data, "error")) {
          data.error(command);
        }
      } else if (command.last_status == "failed" && command.result != null) {
        update.type = toast.TYPE.ERROR;
        end = true;

        let errorDJI = API.getFirstData(
          await API.get("djierror", {
            ErrId: command.result,
          })
        );

        let msgErreur = $root.$dji_error(command.result);
        console.error("errorDJI →", errorDJI);
        data.name += " (" + msgErreur + ")";

        if (Object.hasOwnProperty.call(data, "error")) {
          data.error(command);
        }
      } else if (command.last_status == "ok" && command.result != null) {
        update.type = toast.TYPE.SUCCESS;
        end = true;

        if (Object.hasOwnProperty.call(data, "success")) {
          data.success(command);
        }
      }

      if (!end) {
        toast.update(msg_replie.ToastId, update);
        return;
      }
      msg_replie.close = true;
      toast.remove(msg_replie.ToastId);
      delete this.app.msg_replie[data.id];

      setTimeout(
        (id) => {
          document.getElementById(id)?.remove();
        },
        250,
        msg_replie.ToastId
      );

      let toastMsgReplie = {
        ...this.app.$root.toastMsgReplie
      }

      toastMsgReplie.type = update.type;
      toastMsgReplie.autoClose = 2000;

      toast(data.name, toastMsgReplie);
    }
  }
}

export default MessageReplie;
